<template>
<div class="zoom-slider">
  <input class="zoom-slider-decrement" type="button" @click="decrementZoom">
  <input class="zoom-slider-range" v-model.number="zoom" type="range" :min="min" :max="max">
  <input class="zoom-slider-increment" type="button" @click="incrementZoom">
  <em class="zoom-slider-scale1"></em>
  <em class="zoom-slider-scale2"></em>
  <em class="zoom-slider-scale3"></em>
  <em class="zoom-slider-base"></em>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { app, grid } from '../display'

export default {
  data() {
    return {
      min: 1,
      max: 5,
    }
  },
  computed: {
    zoom: {
      get () {
        return this.$store.state.editor.zoom
      },
      set (value) {
        this.updateZoom(value)
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('editor', ['updateZoom']),
    decrementZoom() {
      if (this.zoom > this.min) {
        this.zoom -= 1
      }
    },
    incrementZoom() {
      if (this.zoom < this.max) {
        this.zoom += 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/bootstrap";
.zoom-slider {
  position: absolute;
  right: 10px;
  bottom: 7px;
  display: flex;
  align-items: center;
}
.zoom-slider-increment,
.zoom-slider-decrement {
  flex: 0 0 auto;
  -webkit-appearance: none;
  display: block;
  width: 21px;
  height: 21px;
  border: 0;
  border-radius: 10px;
  @include transition($btn-transition);
  @include button-variant($primary, $primary, #A4CB3F, #A4CB3F, #A4CB3F, #A4CB3F);
  background-repeat: no-repeat;
  background-position: center center;
  color: #fff;
  cursor: pointer;
  &:focus {
    outline: none;
  }
}
.zoom-slider-increment {
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewbox%3D%220%200%209%209%22%20width%3D%229%22%20height%3D%229%22%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22M6%2C9H3V6H0V3h3V0h3v3h3v3H6V9z%22%2F%3E%3C%2Fsvg%3E');
}
.zoom-slider-decrement {
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewbox%3D%220%200%209%209%22%20width%3D%229px%22%20height%3D%229px%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%2C3%20L9%2C3%20L9%2C6%20L0%2C6%20L0%2C3%20Z%22%2F%3E%3C%2Fsvg%3E');
}
.zoom-slider-range {
  -webkit-appearance: none;
  margin: 0 3px;
  width: 117px;
  height: 21px;
  background: transparent;
  z-index: 10;
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    padding: 0;
    width: 100%;
    background: transparent;
    cursor: pointer;
  }
  &::-webkit-slider-thumb {
    border: 1px solid #999999;
    height: 21px;
    width: 10px;
    @include gradient-x(#fff, #ddd);
    cursor: pointer;
    -webkit-appearance: none;
  }
  &::-moz-range-track {
    padding: 0;
    width: 100%;
    cursor: pointer;
    background: transparent;
  }
  &::-moz-range-thumb {
    border-radius: 0;
    border: 1px solid #999999;
    height: 21px;
    width: 10px;
    @include gradient-x(#fff, #ddd);
    cursor: pointer;
  }
  &::-ms-track {
    padding: 0;
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: transparent;
  }
  &::-ms-fill-upper {
    background: transparent;
  }
  &::-ms-thumb {
    margin: 0;
    padding: 0;
    border: 1px solid #999999;
    border-radius: 0;
    height: 19px;
    width: 8px;
    @include gradient-x(#fff, #ddd);
    cursor: pointer;
  }
  &::-ms-tooltip {
    display: none;
  }
}
.zoom-slider-scale1 {
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 50%;
  bottom: 4px;
  display: block;
  margin-left: -26px;
  width: 1px;
  background: #626262;
}
.zoom-slider-scale2 {
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 50%;
  bottom: 4px;
  display: block;
  margin-left: -1px;
  width: 2px;
  background: #626262;
}
.zoom-slider-scale3 {
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 50%;
  bottom: 4px;
  display: block;
  margin-left: 25px;
  width: 1px;
  background: #626262;
}
.zoom-slider-base {
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 21px;
  right: 21px;
  display: block;
  height: 5px;
  cursor: pointer;
  background: #626262;
}
</style>



// WEBPACK FOOTER //
// assets/js/components/ZoomSlider.vue